import { render, staticRenderFns } from "./WarehouseManagement.vue?vue&type=template&id=ed28318c"
import script from "./WarehouseManagement.vue?vue&type=script&lang=js"
export * from "./WarehouseManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports